import { cn } from '../lib/utils';
import React from 'react';
import { motion } from 'framer-motion';
import { trackInitiateCheckout, ProductKey } from './MetaPixel';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} className={className} data-id="element-397" data-mp="184w23sf39ldm">
    {children}
  </motion.div>;
interface ButtonProps {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  className?: string;
  /**
   * When set, fires Meta Pixel `InitiateCheckout` with the
   * matching value + currency right before the link navigates.
   */
  trackingProduct?: ProductKey;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export const CTAButton = ({
  href,
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  trackingProduct,
  onClick
}: ButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (trackingProduct) {
      try {
        trackInitiateCheckout(trackingProduct);
      } catch {
        // never block navigation on tracking failure
      }
    }
    // Drop focus so the button never stays "lit" when the user comes back
    // to the page from the checkout (mobile keeps :focus otherwise).
    e.currentTarget.blur();
    if (onClick) onClick(e);
  };
  const isExternal = href.startsWith('http');
  return <a href={href} onClick={handleClick} rel={isExternal ? 'noopener' : undefined} className={`
        inline-flex items-center justify-center gap-2 transition-[transform,background-color,border-color,color,box-shadow] duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-brandGold focus-visible:ring-offset-2 focus-visible:ring-offset-bg-base
        ${fullWidth ? 'w-full' : ''}
        ${variant === 'primary' ? 'bg-brandGold text-[#14100A] font-sans font-extrabold uppercase tracking-wide text-base px-9 py-4 rounded-[14px] shadow-[0_0_30px_rgba(212,162,76,0.4),0_4px_16px_rgba(212,162,76,0.3)] [@media(hover:hover)]:hover:bg-brandGold-hover [@media(hover:hover)]:hover:-translate-y-0.5 [@media(hover:hover)]:hover:shadow-[0_0_50px_rgba(212,162,76,0.58)] animate-glow-button' : 'bg-bg-card text-txt-primary font-bold border border-line [@media(hover:hover)]:hover:bg-bg-highlight [@media(hover:hover)]:hover:border-brandGold/50 text-[15px] px-8 py-4 rounded-[14px]'}
        ${className}
      `} data-id="element-398" data-mp="2gw5214dujud2">
      {children}
    </a>;
};
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <section id={id} className={cn(`py-10 md:py-20 px-4 md:px-6 overflow-hidden ${className}`, 'pt-[20px] pb-[0px]', 'pb-[10px]')} data-id="element-399" data-mp="2uvzkoie9rbl0">
    <div className="max-w-[1100px] mx-auto" data-id="element-400" data-mp="o80atw4tkcj0">{children}</div>
  </section>;